import { Carousel } from 'bootstrap';
import axios from 'axios';

const DateToString = {
  data() {
    return {
      date: new Date(),
    };
  },
  mounted() {
    const vm = this;
    setInterval(() => {
      vm.date = new Date();
    }, 1000);
  },
  methods: {
    dateToString() {
      const month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(this.date);
      const dayNumber = this.date.getDate();
      const separator = '<span class="text-primary">|</span>';
      const time = this.date.toLocaleTimeString('en-US', { hour12: true, hour: 'numeric', minute: '2-digit' });
      return `${month} ${dayNumber} ${separator} ${time}`;
    },
  },
};

const Slides = {
  data() {
    return {
      echo: null,
      info: [],
      myComponents: {},
      marqueeText: '',
      textBuffer: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      interval: 8000,
      slideChange: 0,
      heading: '',
      smallAds: [],
      activeAd: 0,
      adChange: new Date(),
      cacheBuster: new Date(),
      radarCacheBuster: new Date(),
      alert: {
        active: false,
        message: '',
      },
    };
  },
  methods: {
    initializeCarousel() {
      const vm = this;
      const carouselInterval = setInterval(() => {
        const myCarousel = document.querySelector('#carousel-fade');
        if (myCarousel) {
          new Carousel(myCarousel).cycle();
          myCarousel.addEventListener('slide.bs.carousel', (event) => {
            vm.visibilityChanged(event.to);
          });
          clearInterval(carouselInterval);
        }
      }, 100);
    },
    isActive(index) {
      return index === this.slideChange;
    },
    setActive(activeIndex) {
      if (this.myComponents[activeIndex]) {
        if (Object.prototype.hasOwnProperty.call(this.myComponents[activeIndex], 'interval')) {
          this.interval = this.myComponents[activeIndex].interval * 1000;
        } else {
          this.interval = 8000;
        }

        if (Object.prototype.hasOwnProperty.call(this.myComponents[activeIndex], 'heading')) {
          this.heading = this.myComponents[activeIndex].heading.toUpperCase();
        } else {
          this.heading = '';
        }

        if (Object.prototype.hasOwnProperty.call(this.myComponents[activeIndex], 'ads')) {
          if (this.myComponents[activeIndex].ads) {
            this.activeAd++;
          }
        }
      }
    },
    visibilityChanged(event) {
      let index = event;
      if (index === 0) {
        this.adChange = new Date();
      }
      if (index === -1) {
        index = this.slideChange;
      }
      this.setActive(index);
      this.slideChange = index;
    },
    getSideAds() {
      const vm = this;
      axios.get(`${window.location.origin}/api/small-ads`)
        .then((response) => {
          vm.smallAds = response.data;
        });
    },
    componentPadding(type) {
      switch (type) {
        case 'off_peak_status':
          return 'pt-4';
        default:
          return 'pt-5';
      }
    },
    backgroundImage(component) {
      if (Object.prototype.hasOwnProperty.call(component, 'background')) {
        return {
          'background-image': `url('/storage/background/${component.background.name}')`,
        };
      }
      if (Object.prototype.hasOwnProperty.call(component, 'background_image_file_name')
      ) {
        return {
          'background-image': `url('/images/weather_images/${component.background_image_file_name}.jpg')`,
        };
      }
      if (Object.prototype.hasOwnProperty.call(component, 'city')) {
        return {
          'background-image': `url('/images/weather_images/${this.info
            .currentConditions[component.city].background_image_file_name}.jpg')`,
        };
      }
      return {
        'background-image': `url('/images/weather_images/${this.info.defaultBackground}.jpg')`,
      };
    },
  },
};

export {
  DateToString,
  Slides,
};
